import Button from "@/components/Button"
import cn from "@/utils/cn"
import { copyErrorToClipboard } from "@/utils/utils"
import { ComponentPropsWithRef, useState } from "react"

type CopyErrorButtonProps = {
  error: unknown
} & Omit<ComponentPropsWithRef<typeof Button>, "variant">

const CopyErrorButton = ({
  error,
  className,
  ...otherProps
}: CopyErrorButtonProps) => {
  const [isCopied, setIsCopied] = useState(false)
  return (
    <Button
      variant="neutral"
      className={cn("h-[32px] w-[100px]", className)}
      onClick={() => {
        copyErrorToClipboard(error)
        setIsCopied(true)
      }}
      {...otherProps}
    >
      {isCopied ? "Copied!" : "Copy error"}
    </Button>
  )
}

export default CopyErrorButton
